// import * as dotenv from 'dotenv'
import { ref } from "vue";
import config from "/config.json";

export function useApi() {
  const tokenCSRF = ref();

  const api = (version = "v1") => {
    return `${config.API_URL}/${version}`;
  };

  return {
    api,
    tokenCSRF,
  };
}
